const React = require('react');
const ReactDOM = require('react-dom');

const css = require('./module.scss');

class Foot extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div className = "fp-foot">
            <div className="fp-foot-content-wrap">
                <div className="fp-foot-list">
                    <a>新手指南</a>
                    <a>关于我们</a>
                    <a>售后服务</a>
                    <a>物流配送</a>
                    <a>商务合作</a>
                </div>
                <p className="tMgt20 tMgb10">中国—东盟信息港股份有限公司承建</p>
                <p>Copyright &copy;东信创联 All Rights Reserved</p>
            </div>
        </div>;
    }
}

module.exports = Foot;



// WEBPACK FOOTER //
// ./component/frame/foot.js